<template>
  <main class="bg-grid">
    <section class="mb-2 pb-2 border-b">
      <PageTitleVue :small="true" subTitle="Ultimos horarios registrados">
        ULTIMOS REGISTROS

        <template #b-action>
          <div class="w-full">
            <Titles
              class="uppercase font-semibold"
              :w25="true"
              :left="false"
              :label="date"
            />
          </div>
        </template>
      </PageTitleVue>

      <!-- table -->
      <section>
        <div
          class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-[35vh] md:max-h-[45vh] p-2"
        >
          <DataTable :data="filteredData">
            <template #head>
              <th scope="col" class="px-6 py-3">Nome</th>
              <th scope="col" class="px-6 py-3">Registro</th>
              <th scope="col" class="px-6 py-3 text-center">#</th>
            </template>
          </DataTable>
          <small class="text-gray-400"> ultimos 7 registros </small>
          <div
            class="sticky -bottom-2 h-10 bg-gradient-to-t from-white to-transparent pointer-events-none z-20"
          ></div>
        </div>
      </section>
    </section>

    <section>
      <PageTitleVue 
        :small="true" 
        :withHeader="false"
        :subTitle="`Estatistica semanal - ${startPeriod ?? ''} a ${endPeriod ?? ''}`"
      >
        Funcionários
      </PageTitleVue>

      <!-- cards -->
      <section class="mx-2">

        <div class="w-full">
          <div class="grid place-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 p-0 relative">
            <router-link
              v-for="(item, index) in dataCards" :key="index"
              class="flex border border-gray-200 rounded-lg shadow md:flex-row hover:scale-105 hover:shadow-xl transition-all m-2 w-full"
              :to="`/collab-statistics/${item['id']}`"
            >
              <img
                class="object-cover h-40 w-40 md:h-40 md:w-48 rounded-t-lg md:rounded-none md:rounded-s-lg p-1"
                :src="
                  item['image_profile'] 
                    ? profileImageUrl + item['image_profile'] 
                    : defaultImg
                "
                :alt="`Foto ${item['name']}`"
                height="20"
              />
  
              <div class="flex flex-col justify-between leading-normal p-1 bg-gray-50 w-full">
                <h5
                  class="text-xl font-bold tracking-tight text-gray-900 mt-auto mb-auto text-center"
                >
                  {{ item['name'] }}
                </h5>

                <!-- <section class="grid place-items-center grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 p-0 "> -->
                <section class="p-0 w-full mb-5">
                  <div class="w-[95%] ml-auto mr-auto flex flex-col text-left">
                    <small>
                      h. trabalhadas: 
                      <strong>
                        {{ item['hTrab'] }}  
                      </strong>

                      {{ 
                        item['h_semanais'] 
                          ? '/ ' + item['h_semanais'] + 'h' 
                          : '' 
                      }}
                    </small>

                    <small>
                      h. devedoras: 
                      <label class="text-red-600 font-bold">
                        {{ item['hDeve'] }}
                      </label>
                    </small>

                    <small>
                      banco de horas: 
                      <label class="text-[#7c9c40] font-bold">
                        {{ item['hExtras'] }}
                      </label>
                    </small>
                  </div>
                </section>
              </div>
            </router-link>
          </div>
        </div>
      </section>
    </section>
  </main>
</template>

<script setup>
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import DataTable from "./components/DataTable.vue";
import homeService from "./services/home.service";
import Titles from "./components/Titles.vue";
import { onMounted, ref } from "vue";
import { storeApp } from "@/store";
import { dataHome } from "./store";
import { computed } from "vue";

let profileImageUrl = process.env.VUE_APP_IMAGE_SERVE.concat('storage/')
const defaultImg = ref(require('@/assets/logo/app.png'))
const store = dataHome;
const startPeriod = ref(null)
const endPeriod = ref(null)

const dataTable = computed(() => {
  return store.getters.getLatestRecords;
});

const filteredData = computed(() => {
  return dataTable.value;
});

const dataCards = computed(() => store.getters.getAllCollabs)

const today = new Date();
const dayNames = [
  "domingo",
  "segunda-feira",
  "terça-feira",
  "quarta-feira",
  "quinta-feira",
  "sexta-feira",
  "sábado",
];
const monthNames = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];
const date = `${dayNames[today.getDay()]}, ${today.getDate()} de ${monthNames[today.getMonth()]} de ${today.getFullYear()}`;

async function getRecords() {
  await homeService.latestRecords()
    .then((res) => {
      store.dispatch("setRecordsList", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

async function getAllCollabs () {
  storeApp.state.loading = true
  await homeService.getCollabs()
    .then(res => {
      startPeriod.value = res.data.start
      endPeriod.value = res.data.end
      store.dispatch('setAllCollabs', res.data.cards);
    }).catch(err => {
      return toast(
        'Aviso',
        'Algo deu errado ao buscar dados do colaborador',
        'error'
      )
    }).finally(() => {
      storeApp.state.loading = false
    })
}

onMounted(() => {
  storeApp.state.loading = true;
  Promise.allSettled([
    getRecords(),
    getAllCollabs()
  ]);
  storeApp.state.loading = false;
});
</script>

<style>
/* From Uiverse.io by kandalgaonkarshubham */
.bg-grid {
  width: 100%;
  height: 100%;
  --s: 27px; /* control the size */
  --c: #0000, #28282803 0.5deg 119.5deg, #0000 120deg;
  --g1: conic-gradient(from 60deg at 56.25% calc(425% / 6), var(--c));
  --g2: conic-gradient(from 180deg at 43.75% calc(425% / 6), var(--c));
  --g3: conic-gradient(from -60deg at 50% calc(175% / 12), var(--c));
  background: var(--g1), var(--g1) var(--s) calc(1.73 * var(--s)), var(--g2),
    var(--g2) var(--s) calc(1.73 * var(--s)), var(--g3) var(--s) 0,
    var(--g3) 0 calc(1.73 * var(--s)) #1e1e1e00;
  background-size: calc(2 * var(--s)) calc(3.46 * var(--s));
}
</style>
